import { useCallback, useMemo, useState } from "react";
import { Button } from "@mantine/core";
import { useQueryClient } from "@tanstack/react-query";
import { useHasPermission } from "../../../hooks/useHasPermission";
import { sendOutKeys } from "../../../hooks/useSendOuts";
import LogNewSendOutModal from "../../send-outs/LogNewSendOutModal";

interface Props {
  caseId: string;
  caseNumber: string;
}

export default function LegacySendOutAction({ caseId, caseNumber }: Props) {
  const [opened, setOpened] = useState(false);
  const canManage = useHasPermission("send_outs.manage");
  const client = useQueryClient();
  const initialCase = useMemo(
    () => ({
      id: caseId,
      caseNumber,
      isLegacyImported: true,
      currentStatus: { name: "Completed" },
    }),
    [caseId, caseNumber]
  );
  const handleOpen = useCallback(() => setOpened(true), []);
  const handleClose = useCallback(() => setOpened(false), []);
  const handleSuccess = useCallback(() => {
    setOpened(false);
    void client.invalidateQueries({ queryKey: sendOutKeys.byCase(caseId) });
  }, [caseId, client]);
  if (!canManage) return null;
  return (
    <>
      <Button variant="default" onClick={handleOpen}>
        Log send-out
      </Button>
      {opened && (
        <LogNewSendOutModal
          opened
          onClose={handleClose}
          initialCase={initialCase}
          onSuccess={handleSuccess}
        />
      )}
    </>
  );
}
